import { useEffect, useRef } from 'react'
import { usePostHog } from 'posthog-js/react'

interface WelcomeStepProps {
    onNext: () => void
    onSkip: (step: number) => void
}

export default function WelcomeStep({ onNext, onSkip }: WelcomeStepProps) {
    const posthog = usePostHog()
    const firedRef = useRef(false)

    useEffect(() => {
        if (!firedRef.current) {
            posthog.capture('onboarding_started')
            firedRef.current = true
        }
    }, [posthog])

    return (
        <div className="welcome-step">
            {/* Animated growth chart */}
            <div className="welcome-chart" aria-hidden="true">
                <svg viewBox="0 0 400 200" className="chart-svg">
                    <defs>
                        <linearGradient id="lineGrad" x1="0" y1="0" x2="1" y2="0">
                            <stop offset="0%" stopColor="#1B365D" />
                            <stop offset="100%" stopColor="#C9A227" />
                        </linearGradient>
                        <linearGradient id="fillGrad" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="0%" stopColor="#C9A227" stopOpacity="0.25" />
                            <stop offset="100%" stopColor="#C9A227" stopOpacity="0" />
                        </linearGradient>
                    </defs>

                    {/* Area fill */}
                    <path
                        d="M10 185 C 60 175, 100 160, 150 140 C 200 118, 230 90, 280 60 C 320 35, 360 18, 390 10 L 390 195 L 10 195 Z"
                        fill="url(#fillGrad)"
                        className="chart-fill"
                    />

                    {/* Growth curve */}
                    <path
                        d="M10 185 C 60 175, 100 160, 150 140 C 200 118, 230 90, 280 60 C 320 35, 360 18, 390 10"
                        fill="none"
                        stroke="url(#lineGrad)"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        className="chart-line"
                    />

                    {/* "Your Goal" milestone marker */}
                    <g className="milestone-marker">
                        <circle cx="390" cy="10" r="6" fill="#C9A227" />
                        <g className="milestone-sparkle">
                            <circle cx="390" cy="10" r="10" fill="none" stroke="#C9A227" strokeWidth="1" opacity="0.6" />
                            <circle cx="390" cy="10" r="14" fill="none" stroke="#C9A227" strokeWidth="0.5" opacity="0.3" />
                        </g>
                        <rect x="305" y="-8" width="80" height="18" rx="4" fill="#C9A227" />
                        <text x="345" y="6" textAnchor="middle" fill="#1B365D" fontSize="9" fontWeight="700">
                            Your Goal
                        </text>
                    </g>
                </svg>
            </div>

            {/* Copy */}
            <h1 className="welcome-headline">Welcome to Steadfast HSA</h1>
            <p className="welcome-subheadline">
                The receipt vault for people who think in decades.
            </p>

            {/* Actions */}
            <div className="welcome-actions">
                <button
                    className="btn btn-primary btn-lg"
                    onClick={onNext}
                    id="welcome-cta"
                >
                    Let's set up your vault →
                </button>
                <button
                    className="btn-link skip-link"
                    onClick={() => onSkip(1)}
                    id="welcome-skip"
                >
                    Skip setup
                </button>
            </div>
        </div>
    )
}
